<template>
  <FKBreadCrumb :page="$t('page.edit')" :title="$t('page.edit_caregiver')">
    <FKBreadCrumbItem :page="$t('page.patients')" to="/patients" />
    <FKBreadCrumbItem :page="patient_fullname" :to="`/patient/${patient.id}`" />
    <FKBreadCrumbItem :page="$t('page.caregivers')" :to="`/patient/${patient.id}/caregivers`" />
  </FKBreadCrumb>
  <CaregiverForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CaregiverForm from "@/components/FK/Caregivers/CaregiverForm.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import { PatientInfo } from "@/utils/models/user.model";

export default defineComponent({
  name: "CaregiverFormPage",
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    CaregiverForm,
  },
  data() {
    return {
      patient: this.$route.meta.patient as PatientInfo,
    }
  },
  computed: {
    patient_fullname(): string { return `${this.patient.firstname} ${this.patient.lastname}` },
  },
});
</script>